import { Box, Button, Snackbar, Typography, useTheme } from "@mui/material";
import footerNavConfig from "~src/layouts/app/navbar/FooterNavConfig";
import Iconify from "./Iconify";
import { useState } from "react";

type PropsType = {
  initialLoad: boolean;
};

export function AdBlockerNotification(initialLoad: PropsType) {
  const theme = useTheme();
  const [close, setClose] = useState(false);
  if (close || !initialLoad.initialLoad) return null;
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      open={true}
    >
      <Box
        sx={{
          maxWidth: "50%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          <Button onClick={() => setClose(true)}>
            <Iconify icon={"material-symbols:close"} width={25} height={25} />
          </Button>
        </Box>
        <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
          If you're having trouble loading the ads page, please make sure you
          don’t have an active ad blocker. Learn more in the{" "}
          <span>
            <a
              target="_blank"
              href={
                footerNavConfig[0].items.find(
                  (item) => item.title === "Support",
                )?.path
              }
              style={{ color: theme.palette.primary.dark, fontWeight: 600 }}
            >
              FAQ help center{" "}
            </a>
          </span>
        </Typography>
      </Box>
    </Snackbar>
  );
}
